import React from 'react';
import FilterCenterFocusIcon from '@mui/icons-material/FilterCenterFocus';
import { IconButton, Tooltip } from '@mui/material';
import paper from 'paper';

import { fitToPage } from '../../modules/annotations/canvasManager';
import { useAppSelector } from '../hooks';

function onFitToPageClicked() {
  const baseImage = paper.project.activeLayer.children[0] as paper.Raster;
  fitToPage(baseImage.width, baseImage.height);
}

export default function FitToPage() {
  const textAnnotationBeingEditedInlineGuid = useAppSelector(
    (state) => state.annotations.textAnnotationBeingEditedInlineGuid,
  );
  return (
    <div>
      <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Fit To Page">
        <div>
          <IconButton
            aria-label="Fit To Page"
            onClick={onFitToPageClicked}
            sx={{ borderRadius: 0 }}
            // If a text annotation is being edited inline, fit to page is disabled because the size of the rendered
            // textarea does not update when `fitToPage` is called directly here. In the future, changing the zoom
            // may be more controlled such that this does not need to be disabled.
            disabled={!!textAnnotationBeingEditedInlineGuid}
          >
            <FilterCenterFocusIcon />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
}
